export default "__VITE_ASSET__CPKkxSyM__"